import $http from '@/plugins/http.js'

//行业咨询查询
export function ttIndustryInformationEnglish(params) {
    return $http.get('/english/ttIndustryInformationEnglish/page', params)
}

//行业咨询查询详情页面
export function ttIndustryInformationEnglishDetails(params) {
    return $http.get('/english/ttIndustryInformationEnglish/'+params)
}



//国内产销数据批发量/零售量
export function YkbQcCxDataChart(params) {
    return $http.get('/english/YkbQcCxData/chart', params)
}

//分车型数据
export function getTableData(params) {
    return $http.get('/english/YkbQcPPData/getTableData', params)
}

